import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=5f33ea75&scoped=true&"
import script from "./Texts.vue?vue&type=script&lang=js&"
export * from "./Texts.vue?vue&type=script&lang=js&"
import style0 from "./Texts.vue?vue&type=style&index=0&id=5f33ea75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33ea75",
  null
  
)

export default component.exports